<p-breadcrumb
  [model]="[
    { label: 'Textos', routerLink: ['/text-contents'] },
    {
      label: 'Editar Texto',
      routerLink: ['/text-contents/update', textContentId()],
    },
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        <h5 class="font-bold">Editar Texto</h5>
        <p>Atualize o conteúdo do texto</p>
      </div>

      <div class="flex justify-end gap-2">
        <p-button
          label="Cancelar"
          routerLink="/text-contents"
          severity="secondary"
          rounded
          class="btn-secondary-outline"
        >
        </p-button>
        <p-button
          type="submit"
          label="Salvar"
          [disabled]="formGroup.invalid"
          rounded
        ></p-button>
      </div>
    </div>
  </p-toolbar>

  <div class="card space-y-5 w-full">
    <h5 class="font-bold">Informações do texto</h5>

    <div class="w-full">
      <label for="slug">Slug</label>
      <input pInputText type="text" formControlName="slug" class="w-full" />
      <app-form-error [control]="formGroup.get('slug')" />
      <app-form-server-error [control]="formGroup.get('slug')" />
    </div>

    <div class="w-full">
      <label for="slug">Descrição</label>
      <input pInputText type="text" formControlName="description" class="w-full" />
      <app-form-error [control]="formGroup.get('description')" />
      <app-form-server-error [control]="formGroup.get('description')" />
    </div>

    <div class="w-full">
      <label for="content">Conteúdo *</label>
      <quill-editor
        formControlName="content"
        class="content-editor"
        style="width: 100%"
        placeholder="Informe o conteúdo"
        [modules]="quillModules"
        [formats]="quillFormats"
      ></quill-editor>
      <app-form-error [control]="formGroup.get('content')" />
      <app-form-server-error [control]="formGroup.get('content')" />
    </div>
  </div>

  @if (loading()) {
    <div
      class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
    >
      <p-progress-spinner ariaLabel="loading" />
    </div>
  }
</form>

<p-toast />
